// extracted by mini-css-extract-plugin
export default {"body":"PointsModal-module__body--dde33","footer":"PointsModal-module__footer--d63d8 Modals-module__footer--e47b9"};